import * as React from "react";
import { Link as MuiLink } from "@mui/material";
import { useTinyHost } from "@tiny/host-contract";
import LongLeft from "@tiny/icons/generated/LongLeft";

interface BackNavigationProps {
  backUrl?: string;
  className?: string;
}

function BackNavigation({ backUrl, className }: BackNavigationProps) {
  const { navigate } = useTinyHost();
  const target = navigate.getReturnPath?.() || backUrl || "";

  if (!backUrl) {
    return null;
  }
  return (
    <MuiLink
      component="button"
      onClick={() => navigate.to(target)}
      className={className}
      sx={{ display: "inline-flex", alignItems: "center" }}
    >
      <LongLeft />
    </MuiLink>
  );
}

export default BackNavigation;
